import React,{useEffect} from "react";
import { useParams } from "react-router-dom";
import { industries } from "../Data";
import About from '../Components/About';
import IndustryChallenges from "../Components/IndustryChallenges";
import ServicePoints from "../Components/ServicePoints";
import OurNetwork from "../Components/OurNetwork";
import IndustryUseCase from "../Components/IndustryUseCase";
import Whychoose from "../Components/WhyChoose";
import ServiceCta from "../Components/ServiceCta";

const IndustryDetail=()=>{
     const { slug } = useParams();

  const industry = industries.find(item => item.slug === slug);

  useEffect(() => {
      if (!industry) return;
      document.title = `${industry.metaTitle}`;
      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
  
      if (metaDesc) {
        metaDesc.setAttribute("content", industry.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://shivamtransworld.in/industries/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      industry.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      industry.metaDesc
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://shivamtransworld.in/industries/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     industry.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
     industry.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    }, [industry, slug]);


  if (!industry) {
    return <h2>Industry not found</h2>;
  }

    return(
        <>
         <React.Fragment key={slug}>
        <div className="spacing-div"></div>

        <About
          subheading={industry.subheading}
          heading={industry.pageheading}
          headingTag="h1"
          subtext={industry.subText}
          buttonText="Get a Quote"
          image={industry.image}
          buttonLink="/enquiry#enquiry-form"
        />

        <IndustryChallenges 
        title={industry.challengeTitle}
        description={industry.challengeDesc}
        cards={industry.challengePoints}
        />

         <ServicePoints
          title={industry.supportTitle}
          desc={industry.supportDesc}
          points={industry.supportPoints}
        />

        <OurNetwork />

        <IndustryUseCase
        title={industry.useCaseTitle}
        description={industry.useCaseDesc}
        items={industry.useCasePoints}
        />

         <Whychoose
          heading={industry.chooseTitle}
          imageSrc={industry.chooseImg}
          paragraph={industry.chooseDesc}
          listItems={industry.choosePoints}
        />

           <ServiceCta
          title={industry.ctaTitle}
          text={industry.ctaText}
          cta={industry.cta}
          bgImage={industry.ctaImage}
        />
         </React.Fragment>
        </>
    )
}

export default IndustryDetail;